'use client';

import { FC, useMemo, useState, useContext } from 'react';
import { Alert, InlineUnsafe } from '@/_components';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';
import { getCookie, setCookie } from 'cookies-next/client';
import {
  SORABAN_GLOBAL_BANNER_COOKIE,
  MAX_COOKIE_AGE,
} from '@/_constants/cookies';
import { UserContext } from '@/_contexts/UserProvider';

const TRD_BANNER_20250307 =
  `<b>New!</b> Enhanced Deliver Features: Bookmarked Returns, Updated AI Classification, Smarter Filters, Bulk Actions - <a href="https://www.loom.com/share/3cc916a167164e1b96432db1fb3dff21">Click To View A Walkthrough</a>
` as const;

export const GlobalBannerAlert: FC = () => {
  const { isAdvisor } = useContext(UserContext);
  const { preferences } = useContext(FirmSettingsContext);

  const [isDismissed, setIsDismissed] = useState<boolean>(false);

  const dismissedWithCookie: boolean = useMemo(
    () =>
      getCookie(SORABAN_GLOBAL_BANNER_COOKIE) ===
      preferences?.in_app_banner_text,
    [preferences?.in_app_banner_text],
  );

  const onDismissGlobalBanner = () => {
    try {
      setCookie(SORABAN_GLOBAL_BANNER_COOKIE, preferences?.in_app_banner_text, {
        maxAge: MAX_COOKIE_AGE,
      });
      setIsDismissed(true);
    } catch (error) {
      console.error(error);
    }
  };

  const hasGlobalBannerFlags: boolean =
    !!preferences?.in_app_banner_enabled && !!preferences?.in_app_banner_text;

  const hasGlobalBanner: boolean =
    isAdvisor &&
    !(dismissedWithCookie || isDismissed) &&
    (hasGlobalBannerFlags || !!preferences?.new_tax_return_delivery_enabled);

  if (!hasGlobalBanner) return null;

  return (
    <div>
      <Alert
        type="info"
        icon="info"
        onDismiss={onDismissGlobalBanner}
        isLimited={true}
        isFlat={true}
      >
        <InlineUnsafe
          text={preferences?.in_app_banner_text || TRD_BANNER_20250307}
        />
      </Alert>
    </div>
  );
};
